import React from "react";
import { useTranslation } from "react-i18next";
import TopBar from "../../components/TopBar";
import Footer from "../../components/Footer";
import Product from "../../components/home/Product";
import More from "../about/components/more";
import { useNavigate } from "react-router";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const [see, setSee] = React.useState(false)
  const navigate = useNavigate()
  return (
    <div className="">
      <TopBar />
      <div className=" w-[1200px] mx-auto h5:w-full">
        <div className="my-[30px] flex items-center text-[#181512] text-[16px] h5:px-16">
          <div className="text-[#595959] text-[16px] mr-4 cursor-pointer" onClick={() => navigate('/')}>首頁</div>
          /
          <div className="text-[#181512] text-[16px] ml-4">線上購物須知</div>
        </div>
        <br />

        <div className="text-[#181512] text-[44px] font-bold text-center h5:px-16">線上購物須知</div>
        <br />
        <div className="h5:px-16">
          <hr />
          <br /><br />
          <div className=" mb-[30px]">
            <div className="text-[#181512] text-[18px] font-bold mb-20">會員註冊</div>
            <div className="text-[#595959] text-[16px]">
              當您註冊帳號時，請依本網站會員註冊程序之提示，提供正確資料，並即時維持更新，以獲取最佳之服務。<br />
              依註冊帳號與密碼登入本網站後之一切行為，均視為本人所為，當您發現帳號與密碼遭他人盜用或有任何安全疑慮時，請立即通知本網站。<br />
              註冊資料如有不完整、不確實、冒名或重覆等情事，本網站得不經通知逕行拒絕、暫停或永久取消該註冊帳號。<br />
              帳號因非法或不當使用所造成之損害，除經證明係可歸責於本網站外，本網站將不負任何責任。
            </div>
            <br />
            <div className="text-[#181512] text-[18px] font-bold mb-20">購物需知</div>
            <div className="text-[#595959] text-[16px]">
              當您使用本網站進行交易時，應遵守本網站所提供確認商品數量及價格的機制，下單後，門市人員會與您聯繫。<br />
              於本網站通知確認交易成立前，本網站仍保有不接受訂單或取消出貨之權利。如您於使用本網站訂購產品後任意取消訂單、或有任何造成作業困擾或損害之行為，本網站有權暫停或永久取消您的註冊帳號。<br />
              在下訂單前，請確認您已經詳細審閱了本網站的購物需知、運費說明、樓層費等條件，並確認這些條件您可以接受。<br />
              付款完成後開始計算，須等3-5個工作天(不含國定假日)將由門市人員致電與您確認出貨日期。<br />
              官網下訂後，訂單總金額僅為商品消費，除非特別註明，否則並不包含樓層費或是吊車費用。<br />
              訂購前請務必先參考商品頁面之尺寸標示，確認居家空間格局是否合適。<br />
              自取方式需為小件商品並單筆三件內，小件商品為 21825 Korta 方凳、20822 Rund 圓凳、20151 Latt 圓凳、51111 收納小方凳、50115 Forse 托盤、15206 Casual 休閒茶几、50032 Lada 置物櫃、52087 Oka 展示架、52089 Oka 展示架、50450 Oka 收納展示架、50600 Oka 收納展示架、30012 Mod 床頭櫃、37505 床頭櫃、33208 Kube 床頭櫃、30222 床頭櫃、31011 Fin 床頭櫃、30171 Glatt 床頭櫃、30002、TRINA 化妝椅、31016 Stading 化妝椅、50229 桌上型螢幕架、30009 PALL 腳椅、31082 雙層收納櫃、60501 Parla 飾品盒、60199 NATT 文具架、50500 多功能陳列架、52688 Z型邊桌、50121-雙層托盤、30516-床頭櫃。<br />
              因個人感官差異、電腦或裝置顯色、拍攝場景和光線等影響，商品顏色以實品為主，若您是屬於在意顏色差異的消費者，麻煩預約至體驗店參觀實品選購！恕不接受顏色認知差異之理由退、換貨。<br />
              如對商品搬運時自家住宅、出入口、樓梯太狹窄之顧慮，請洽客服。恕不接受空間限制搬運之理由退、換貨。<br />
              依統一發票使用辦法規定: 個人(二聯式)發票一經開立，無法更改或改開公司戶(三聯式)發票。<br />
              因颱風或地震等不可預期的天災因素、進貨海關隨機抽驗檢查等不可預期的臨時因素，詩肯柚木保有修改出貨時間的權力。<br />
              本公司合作的物流，業務範圍並不包含跨出窗外搬運吊車物品、攀爬與吊掛作業，現場物流人員有權拒高危險性工作。<br />
              為預防網路、電話詐騙行為，本公司並不會透過任何簡訊或不明來電告知消費者訂單交易失敗，提供重新匯款或線上刷卡資訊。 與交易相關的保護措施，如您有任何交易上的疑慮，請一律透過本公司客服電話(0800-358-088)確認。
            </div>
            <br />
            <div className="text-[#181512] text-[18px] font-bold mb-20">運費說明</div>
            <div className="text-[#595959] text-[16px]">
              單次運送貨品總額達免運費金額門檻(依賣方規定)，得同一地址免費運送一次；未滿免運費門檻買方須負擔運費。若依賣方規定運送距離為遠程者，運費另計(詳請參閱下方「滿額免運費表」)。<br />
              搬運大型家具(五斗櫃、六斗櫃、七斗櫃、九斗櫃、十二斗櫃、十五格櫃、雙人床墊、180(含)以上餐桌)，送貨地點3樓(含)以上無電梯而需人工搬運服務，每一樓層收搬運費100元。單筆出貨金額超過16萬元，免收搬運樓層費。<br />
              因空間尺寸因素(例如：樓梯過窄、電梯過小、門口過小等)無法直接搬運至指定地點，而需另外處理，致衍生之其他費用(例如：吊車費等)，買方應自行負擔此類其他費用。<br />
              本服務所收取之運費，僅限於搬運詩肯柚木之產品，不包含舊家具的搬運移除。若要移除舊家具產生額外服務行為，則須額外酌搬運服務費。
            </div>
            <br />
            <div className="text-[#595959] text-[16px] px-[60px]">
              <img src={require("../../assets/image/icon1.jpg")} className="w-full block" alt="" />
            </div>
            <br />
            <div className="text-[#181512] text-[18px] font-bold mb-20">退貨須知</div>
            <div className="text-[#595959] text-[16px]">
              若您收到的商品有瑕疵、破損、規格不符的狀況，請於收到貨後七天內與我們聯繫，將有專業門市人員立即為您辦理換貨事宜。<br />
              如您未曾來過實體店面，直接選擇在官網線上訂購，自您簽收貨物起七日內，皆擁有在詩肯柚木官方渠道申請退貨的七天鑑賞期權利。<br />
              請注意鑑賞期並非試用期，到貨七天內請保留產品的商品、附件、包裝、紙箱及所有隨附文件資料的完整，以寄送時的包裝備妥，若有相關贈品請一併退回，包裝外盒損毀、商品缺件、超過七天猶豫期或是包材不完整、明顯有使用、組裝痕跡致無法再次進行銷售者，恕無法受理退貨及退款。<br />
              退貨只以商品金額為主，已經產生並提供的服務如「運費」、「樓層費」等相關服務恕不在退貨金額範疇。<br />
              信用卡退款時間依各家銀行有所不同，約為14-21 個工作天。<br />
              如發票形式為紙本，請務必保留發票收據。<br />
              同意為加速退貨退款作業辦理，由本公司代為處理電子發票及銷貨退回證明單。<br />
              未授權處理網路銷折請參閱下方： 銷貨折讓單簽回方式。
            </div>
            <br />
            <div className="text-[#595959] text-[16px] px-[60px]">
              <img src={require("../../assets/image/icon2.jpg")} className="w-full block" alt="" />
            </div>
            <br />
            <div className="text-[#595959] text-[16px]">*貼心小圖示</div>
            <div className="text-[#595959] text-[16px]">下列情形將可能影響您的退貨權益：</div>
            <div className="text-[#595959] text-[16px]">
              商品包裝毀損、封條移除、吊牌標籤拆除、貼膠移除等已使用等情形。<br />
              逾越檢查之必要或可歸責於買受人或收件人之事由，致商品有毀損、零件遺失、毀損或變更者。<br />
              猶豫期非試用期，若您收到商品經必要之檢視後有任何不合意之處，請勿留下使用痕跡，請依照退貨規定辦理退貨。<br />
              因商品本身天然質地特色(色澤差異、木節、紋理、牛皮疤痕等)或工藝特色(刷舊、烤漆、電鍍、玻璃)，因個人因素無法接受，無法以此原由要求退換貨。</div>
            <br />
            <br /><br /> <br /><br /> <br /><br />
          </div>
        </div>


      </div>

      <Footer />
    </div>
  );
};

export default ComponentName;
